import OriginalsHelper from "../../Components/OriginalsCustom/Index.js";

const OriginalsCustomDevPage = () => {
  return <OriginalsHelper />;
};

export default OriginalsCustomDevPage;
